import { render, staticRenderFns } from "./configHousekeepingArea.vue?vue&type=template&id=efdb4722&"
import script from "./configHousekeepingArea.vue?vue&type=script&lang=js&"
export * from "./configHousekeepingArea.vue?vue&type=script&lang=js&"
import style0 from "./configHousekeepingArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports